import { useLpControl, useMediaQuery } from '@itau-loans-www/hooks'
import { sdkAnalytics } from '@itau-loans-www/services'
import { isClient } from '@itau-loans-www/utils'

export const useWhatsAppSection = () => {
  const isDesktop = useMediaQuery('desktop')
  const { setOpenWppModal } = useLpControl()

  const handleClick = () => {
    sdkAnalytics.track('trackClick', 'btn:contratar-via-whatsapp')

    if (isDesktop) {
      setOpenWppModal(true)

      return
    }

    isClient() &&
      window.open(
        'https://api.whatsapp.com/send?phone=551140044828&text=simular%20ou%20contratar%20antecipação%20saque%20aniversário%20fgts&?utm_source=canal_proprietario&utm_medium=site&utm_campaign=credito-trafego-ctafixo-externo&utm_content=visitantes-link-mobileedesktop-ctafixo',
        '_blank'
      )
  }

  return { handleClick }
}
